import { Injectable } from '@angular/core';
import { first } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { omitBy } from 'lodash';
import { AppConfigEnvironment, AppConfigSectionNames, defaultAppConfigEnvironment } from '../models/app-config';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments';

const basePath = `${environment.apiBaseUrl}app-config`;

@Injectable({
  providedIn: 'root',
})
export class AppConfigClient {
  constructor(private http: HttpClient) {}

  get<T = Record<string, unknown>>(
    sectionName: AppConfigSectionNames,
    environment: AppConfigEnvironment = defaultAppConfigEnvironment
  ) {
    const searchParams = new URLSearchParams(
      omitBy(
        {
          env: environment,
        },
        p => p == null
      )
    );
    return this.http.get<T>(`${basePath}/${sectionName}?${searchParams.toString()}`);
  }

  async getAsync<T = Record<string, unknown>>(
    sectionName: AppConfigSectionNames,
    environment: AppConfigEnvironment = defaultAppConfigEnvironment
  ) {
    return firstValueFrom(this.get<T>(sectionName, environment).pipe(first()));
  }
}
